import type {
  HeaderLayoutContent,
  HeaderLayoutProps,
} from "scmp-app/components/header/layouts/types";
import {
  AbsoluteCenterFeatureContainer,
  PostMagazineLeftWrapper,
  PostMagazineLogoWrapper,
} from "scmp-app/components/header/styles";

export const getPostMagazineLayout = ({
  features,
  shouldSwap,
}: HeaderLayoutProps): HeaderLayoutContent => ({
  center: (
    <>
      <AbsoluteCenterFeatureContainer>
        {features.postMagazineOnelineMenu({ showIn: "desktopUp" })}
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            showIn: "mobileOnly",
          })}
          {features.postMagazineLogoTextLink({
            showIn: "mobileOnly",
          })}
          {features.postMagazineLogoLink({
            shouldSwap,
            showIn: "tabletOnly",
            showOnSwap: true,
          })}
          {features.postMagazineLogoTextLink({
            shouldSwap,
            showIn: "tabletOnly",
            showOnSwap: true,
          })}
        </PostMagazineLogoWrapper>
      </AbsoluteCenterFeatureContainer>
    </>
  ),
  left: (
    <>
      {features.hamburgerMenu({ showIn: "mobileAndTablet" })}
      <PostMagazineLeftWrapper>
        <PostMagazineLogoWrapper>
          {features.postMagazineLogoLink({
            showIn: "desktopUp",
          })}
          {features.postMagazineLogoTextLink({
            shouldSwap,
            showIn: "desktopUp",
            showOnSwap: true,
          })}
        </PostMagazineLogoWrapper>
        {features.search({ showDesktopDivider: true, showIn: "mobileUp" })}
      </PostMagazineLeftWrapper>
    </>
  ),
  right: (
    <>
      {features.subscription({
        fallback: features.myNews(),
        showIn: "desktopUp",
        variant: "dark",
      })}
      {features.myNews({
        showIn: "mobileAndTablet",
        showWhenLoggedIn: true,
      })}
      {features.dashboard({
        showIn: "mobileUp",
        variant: "postmag",
      })}
    </>
  ),
});
